import React, { useRef, useState, useLayoutEffect, useEffect } from 'react';
import { ARButton, VRButton } from '@react-three/xr';
import { useSnapshot } from 'valtio';

import { state } from '../state';

export function XRButton({
  domOverlayRef,
  wrapperClass = '',
  containerClass = 'nav__cta',
  innerClass = '',
}) {
  // Create a ref to the wrapper div
  const wrapperRef = useRef(null);
  const [defaultLabel] = useState('Launch XR');
  const [supportsVR, setSupportsVR] = useState(false);
  const [supportsAR, setSupportsAR] = useState(false);
  const notSupported = !supportsAR && !supportsVR;
  const { requestedAR } = useSnapshot(state);

  useLayoutEffect(() => {
    if ('xr' in navigator) {
      navigator.xr?.isSessionSupported('immersive-vr').then(function (supportsVR) {
        setSupportsVR(supportsVR);
      });
      navigator.xr?.isSessionSupported('immersive-ar').then(function (supportsAR) {
        setSupportsAR(supportsAR);
      });
    }
    //  else {
    //   if (window.isSecureContext === false) {
    //     setDefaultLabel('WEBXR NEEDS HTTPS');
    //   }
    // }
  }, []);

  // Expose a global function to trigger the XR button from outside React
  useEffect(() => {
    // Create a function to trigger the appropriate button click
    const triggerXRButton = () => {
      if (!wrapperRef.current) return false;
      
      let buttonToClick = null;
      
      if (supportsAR) {
        // Find AR button
        buttonToClick = wrapperRef.current.querySelector('.nav__cta');
      } else if (supportsVR) {
        // Find VR button
        buttonToClick = wrapperRef.current.querySelector('.nav__cta');
      } else {
        // Find fallback button
        buttonToClick = wrapperRef.current.querySelector('.nav__cta');
      }
      
      if (buttonToClick) {
        buttonToClick.click();
        return true;
      }
      return false;
    };
    
    // Expose the function globally
    window.triggerXRButton = triggerXRButton;
    
    // Clean up when component unmounts
    return () => {
      window.triggerXRButton = undefined;
    };
  }, [supportsAR, supportsVR]);

  const domOverlay = domOverlayRef
    ? {
        domOverlay: {
          root: domOverlayRef?.current,
        },
      }
    : {};

  return (
    <div ref={wrapperRef} className={wrapperClass}>
      {supportsAR && (
        <ARButton
          enterOnly
          style={{}} // Remove default styling
          className={containerClass}
          onError={() => {
            // Check if AR requiredFeatures failed and disable AR
            setSupportsAR(false);
            console.warn('AR session failed to start');
          }}
          onClick={() => {
            // share the type of session with the rest of the App
            state.requestedVR = false;
            state.requestedAR = true;
            
            // Set opacity of js__xrCanvas to 1
            const xrCanvas = document.querySelector('.js__xrCanvas');
            if (xrCanvas) xrCanvas.style.opacity = '1';
          }}
          sessionInit={{
            optionalFeatures: ['dom-overlay', 'light-estimation', 'hand-tracking'],
            ...domOverlay,
          }}>
          <span className={innerClass}>Enter AR</span>
        </ARButton>
      )}

      {supportsVR && !supportsAR && (
        <VRButton
          enterOnly
          style={{}} // Remove default styling
          className={containerClass}
          onError={() => {
            // Check if AR requiredFeatures failed and disable AR
            setSupportsVR(false);
            console.warn('VR session failed to start');
          }}
          onClick={() => {
            // share the type of session with the rest of the App
            state.requestedVR = true;
            state.requestedAR = false;
            
            // Set opacity of js__xrCanvas to 1
            const xrCanvas = document.querySelector('.js__xrCanvas');
            console.log('h')
            if (xrCanvas) xrCanvas.style.opacity = '1';
          }}>
          <span className={innerClass}>Enter VR</span>
        </VRButton>
      )}

      {notSupported && (
        <button
          onClick={() => {
            // if (
            //   typeof DeviceMotionEvent !== 'undefined' &&
            //   typeof DeviceMotionEvent.requestPermission === 'function'
            // ) {
            //   DeviceMotionEvent.requestPermission().then(response => {
            //     if (response === 'granted') {
            //       state.useDeviceOrientation = true;
            //     }
            //     state.runFallback = true;
            //   });
            // } else {
            state.runFallback = true;
            // }
            
            // Set opacity of js__xrCanvas to 1
            const xrCanvas = document.querySelector('.js__xrCanvas');
            if (xrCanvas) xrCanvas.style.opacity = '1';
          }}
          className={containerClass}>
          <span className={innerClass}>{defaultLabel}</span>
        </button>
      )}
    </div>
  );
}
